import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const Texas = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Update page title and meta tags
    document.title = 'We Buy Valves Texas | Industrial Equipment Buyers Texas';
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Leading valve buyers in Texas. We purchase surplus valves, Fisher control valves, and instrumentation from Texas refineries and petrochemical plants. Fast quotes and top pricing statewide.');
    }
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'Texas valve buyers, Houston refinery equipment, Dallas industrial equipment, surplus valves Texas, Fisher valves Texas');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/texas');
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Texas Valve Buyers | ValveSalesSupply' },
      { property: 'og:description', content: 'Leading valve buyers in Texas. We purchase surplus valves, Fisher control valves, and instrumentation from Texas refineries and petrochemical plants.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/texas' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/texas/#webpage",
          "url": "https://valvesalessupply.com/texas",
          "name": "Texas Industrial Equipment Buyers - ValveSalesSupply",
          "description": "Professional industrial equipment purchasing services throughout Texas. Serving Houston, Dallas, Austin, San Antonio, Corpus Christi, Beaumont, and El Paso with above scrap rates.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Texas",
                "item": "https://valvesalessupply.com/texas"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/texas/#place",
          "name": "Texas",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 31.9686,
            "longitude": -99.9018
          },
          "containsPlace": [
            {
              "@type": "Place",
              "name": "Houston",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Houston",
                "addressRegion": "TX",
                "addressCountry": "US"
              }
            },
            {
              "@type": "Place", 
              "name": "Dallas",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Dallas",
                "addressRegion": "TX",
                "addressCountry": "US"
              }
            },
            {
              "@type": "Place",
              "name": "Austin",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Austin",
                "addressRegion": "TX",
                "addressCountry": "US"
              }
            },
            {
              "@type": "Place",
              "name": "San Antonio",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "San Antonio",
                "addressRegion": "TX",
                "addressCountry": "US"
              }
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Texas Operations",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "serviceArea": {
            "@type": "State",
            "name": "Texas",
            "addressRegion": "TX"
          },
          "description": "Professional industrial equipment purchasing services throughout Texas, serving major industrial centers including Houston's refinery corridor, Dallas petrochemical facilities, and statewide manufacturing operations."
        },
        {
          "@type": "ItemList",
          "name": "Texas Cities We Serve",
          "numberOfItems": 7,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Houston",
                "url": "https://valvesalessupply.com/houston"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Dallas", 
                "url": "https://valvesalessupply.com/dallas"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Place",
                "name": "Austin",
                "url": "https://valvesalessupply.com/austin"
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Place",
                "name": "San Antonio",
                "url": "https://valvesalessupply.com/san-antonio"
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Place",
                "name": "Corpus Christi",
                "url": "https://valvesalessupply.com/corpus-christi"
              }
            },
            {
              "@type": "ListItem",
              "position": 6,
              "item": {
                "@type": "Place",
                "name": "Beaumont",
                "url": "https://valvesalessupply.com/beaumont"
              }
            },
            {
              "@type": "ListItem",
              "position": 7,
              "item": {
                "@type": "Place",
                "name": "El Paso",
                "url": "https://valvesalessupply.com/el-paso"
              }
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you buy valves from Texas refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Texas refineries including Houston, Beaumont, Port Arthur, Corpus Christi, and all Gulf Coast facilities. We provide fast 4-6 hour response times and competitive pricing for Texas operations."
              }
            },
            {
              "@type": "Question",
              "name": "What cities in Texas do you serve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve all major Texas cities including Houston, Dallas, Austin, San Antonio, Beaumont, Corpus Christi, El Paso, and surrounding areas. We have local teams throughout Texas ready to respond quickly to your equipment purchasing needs."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to Texas facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 4-6 hour response times for Houston and Gulf Coast facilities, and 6-8 hour response times for other major Texas cities. Our local Texas teams have extensive refinery experience and can quickly evaluate your surplus equipment and provide competitive quotes."
              }
            },
            {
              "@type": "Question",
              "name": "What types of equipment do you buy in Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of industrial equipment from Texas facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from refineries, petrochemical plants, and manufacturing facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you handle turnaround equipment removal in Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We specialize in turnaround equipment removal and refinery shutdown equipment purchasing throughout Texas. Our experienced teams work within your schedule to maximize value from surplus assets while maintaining full safety compliance and regulatory documentation."
              }
            },
            {
              "@type": "Question",
              "name": "What brands of valves do you buy in Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Texas refineries and industrial facilities."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const texasCities = [
    { name: 'Houston', refineries: '25+ Refineries', response: '4-6 Hours' },
    { name: 'Beaumont', refineries: '8+ Refineries', response: '4-6 Hours' },
    { name: 'Port Arthur', refineries: '6+ Refineries', response: '4-6 Hours' },
    { name: 'Texas City', refineries: '4+ Refineries', response: '4-6 Hours' },
    { name: 'Baytown', refineries: '3+ Refineries', response: '4-6 Hours' },
    { name: 'Corpus Christi', refineries: '5+ Refineries', response: '6-8 Hours' },
    { name: 'Dallas', refineries: '2+ Facilities', response: '6-8 Hours' },
    { name: 'San Antonio', refineries: '3+ Facilities', response: '6-8 Hours' }
  ];

  const equipmentTypes = [
    {
      category: 'Control Valves',
      brands: ['Fisher', 'Masoneilan', 'Emerson', 'Flowserve'],
      types: ['Ball Valves', 'Gate Valves', 'Globe Valves', 'Butterfly Valves']
    },
    {
      category: 'Instrumentation',
      brands: ['Rosemount', 'Foxboro', 'Allen Bradley', 'Honeywell'],
      types: ['Transmitters', 'Controllers', 'Flow Meters', 'Pressure Gauges']
    },
    {
      category: 'Safety Equipment',
      brands: ['Anderson Greenwood', 'Consolidated', 'Crosby', 'Kunkle'],
      types: ['Relief Valves', 'Safety Valves', 'Rupture Discs', 'Flame Detectors']
    }
  ];

  const allTexasCities = [
    'Abilene', 'Addison', 'Alamo', 'Alice', 'Allen', 'Alpine', 'Alvin', 'Amarillo', 'Andrews', 'Angleton',
    'Arlington', 'Athens', 'Austin', 'Azle', 'Balch Springs', 'Bastrop', 'Bay City', 'Baytown', 'Beaumont', 'Bedford',
    'Beeville', 'Bellaire', 'Belton', 'Benbrook', 'Big Spring', 'Boerne', 'Brenham', 'Brownfield', 'Brownsville', 'Brownwood',
    'Bryan', 'Burleson', 'Carrollton', 'Cedar Hill', 'Cedar Park', 'Cleburne', 'Clute', 'College Station', 'Colleyville', 'Conroe',
    'Converse', 'Coppell', 'Copperas Cove', 'Corpus Christi', 'Corsicana', 'Dallas', 'Deer Park', 'Del Rio', 'Denison', 'Denton',
    'DeSoto', 'Dickinson', 'Donna', 'Duncanville', 'Eagle Pass', 'Edinburg', 'El Paso', 'Euless', 'Farmers Branch', 'Flower Mound',
    'Fort Worth', 'Friendswood', 'Frisco', 'Galveston', 'Garland', 'Georgetown', 'Grand Prairie', 'Grapevine', 'Greenville', 'Haltom City',
    'Harlingen', 'Hereford', 'Houston', 'Humble', 'Huntsville', 'Hurst', 'Irving', 'Keller', 'Kerrville', 'Killeen',
    'Kingsville', 'Kyle', 'La Porte', 'Lake Jackson', 'Lancaster', 'Laredo', 'League City', 'Leander', 'Lewisville', 'Little Elm',
    'Longview', 'Lubbock', 'Lufkin', 'Mansfield', 'Marshall', 'McAllen', 'McKinney', 'Mesquite', 'Midland', 'Mission',
    'Missouri City', 'Nacogdoches', 'New Braunfels', 'North Richland Hills', 'Odessa', 'Orange', 'Palestine', 'Pampa', 'Paris', 'Pasadena',
    'Pearland', 'Pflugerville', 'Pharr', 'Plainview', 'Plano', 'Port Arthur', 'Port Neches', 'Richardson', 'Rockwall', 'Rosenberg',
    'Round Rock', 'Rowlett', 'Sachse', 'San Angelo', 'San Antonio', 'San Benito', 'San Juan', 'San Marcos', 'Schertz', 'Seguin',
    'Sherman', 'Snyder', 'Southlake', 'Stafford', 'Stephenville', 'Sugar Land', 'Sulphur Springs', 'Temple', 'Terrell', 'Texarkana',
    'Texas City', 'The Colony', 'Tyler', 'University Park', 'Uvalde', 'Vernon', 'Victoria', 'Waco', 'Watauga', 'Waxahachie',
    'Weatherford', 'Weslaco', 'Wichita Falls', 'Wylie'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/c707a4e7eb4e256cdb0b0bebabc2a25d.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Texas</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading surplus valve buyer and refinery equipment buyer in Texas. We pay above scrap rates for 
              used industrial valves, control systems, and instrumentation from Houston, Beaumont, Port Arthur, 
              and all Texas refineries and petrochemical plants.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET QUOTE TODAY
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Texas Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">TEXAS INDUSTRIAL EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Texas leads the nation in refining capacity with over 50 major facilities. As the premier 
                <strong className="text-[#1B3A5F]"> valve buyers in Houston</strong> and throughout Texas, we understand 
                the unique challenges of turnaround schedules and the value of quality surplus equipment.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">surplus valves</strong>, 
                <strong className="text-[#1B3A5F]"> used Fisher valves</strong>, Rosemount transmitters, 
                and complete control systems from refineries during planned shutdowns and turnarounds.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">50+</div>
                  <div className="text-gray-600">Texas Refineries</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">4-8 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">25 Years</div>
                  <div className="text-gray-600">Texas Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">MAJOR TEXAS MARKETS WE SERVE</h3>
              <div className="space-y-4">
                {texasCities.map((city, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{city.name}</h4>
                      <p className="text-gray-600 text-sm">{city.refineries}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{city.response}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Major Cities Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">MAJOR TEXAS CITIES WE SERVE</h2>
            <p className="text-gray-600 text-xl">Professional valve buyers in every major Texas industrial market</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                city: 'Houston',
                description: 'Energy Capital - Refineries, Petrochemicals, LNG',
                facilities: '200+ facilities',
                response: '2-3 hours',
                link: '/houston'
              },
              {
                city: 'Dallas',
                description: 'Manufacturing Hub - Industrial, Technology',
                facilities: '150+ facilities',
                response: '3-4 hours',
                link: '/dallas'
              },
              {
                city: 'Austin',
                description: 'Tech Manufacturing - Semiconductors, Electronics',
                facilities: '50+ facilities',
                response: '3-4 hours',
                link: '/austin'
              },
              {
                city: 'San Antonio',
                description: 'Industrial Center - Refining, Manufacturing',
                facilities: '30+ facilities',
                response: '3-4 hours',
                link: '/san-antonio'
              },
              {
                city: 'Beaumont',
                description: 'Golden Triangle - Major Refining Complex',
                facilities: '25+ facilities',
                response: '2-3 hours',
                link: '/beaumont'
              }
            ].map((city, index) => (
              <Link 
                key={index}
                to={city.link}
                className="bg-white border-2 border-gray-200 rounded-3xl p-8 hover:shadow-lg hover:border-[#1B3A5F] transition-all duration-300 block"
              >
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{city.city}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{city.description}</p>
                
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-gray-800 font-semibold">Facilities:</span>
                    <span className="text-[#1B3A5F]">{city.facilities}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-800 font-semibold">Response:</span>
                    <span className="text-[#1B3A5F]">{city.response}</span>
                  </div>
                </div>
                
                <div className="text-[#1B3A5F] font-semibold flex items-center justify-center">
                  View {city.city} Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment We Buy in Texas */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY REFINERY EQUIPMENT TEXAS</h2>
            <p className="text-gray-600 text-xl">Surplus equipment purchasing from Texas refineries and petrochemical plants</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {equipmentTypes.map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Texas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES TEXAS</h2>
            <p className="text-gray-600 text-xl">Texas' leading surplus valve buyers serving all major refining centers</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=surplus%20industrial%20valves%20control%20valves%20gate%20valves%20globe%20valves%20ball%20valves%20Fisher%20Masoneilan%20refinery%20equipment%20warehouse%20storage%20rows%20organized%20professional%20industrial%20photography%20clean%20background&width=600&height=400&seq=texas-surplus-valves-004&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Premium Surplus Valve Inventory</h3>
                  <p>Quality control valves, gate valves, and specialty valves from Texas refineries</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">TEXAS SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are <strong className="text-[#1B3A5F]">Texas' premier surplus valve buyers</strong>, purchasing 
                high-quality used valves from refineries, petrochemical plants, and industrial facilities 
                throughout the state. Our expertise in valve assessment ensures you receive top dollar 
                for your surplus valve inventory.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Control Valves Texas',
                    description: 'Fisher, Masoneilan, Valtek - all sizes and pressure classes',
                    icon: 'ri-settings-3-line'
                  },
                  {
                    type: 'Gate & Globe Valves',
                    description: 'API, ANSI, and specialty gate and globe valves',
                    icon: 'ri-stop-circle-line'
                  },
                  {
                    type: 'Ball & Check Valves',
                    description: 'Trunnion mounted, floating ball, and swing check valves',
                    icon: 'ri-checkbox-circle-line'
                  },
                  {
                    type: 'Safety & Relief Valves',
                    description: 'Anderson Greenwood, Crosby, Consolidated safety valves',
                    icon: 'ri-shield-check-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-6">
                <h4 className="text-[#1B3A5F] font-bold mb-3">Texas Valve Purchase Guarantee:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Above scrap pricing</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Fast 4-8 hour quotes</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Professional removal</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-file-text-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Complete documentation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Turnaround Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=refinery%20turnaround%20shutdown%20equipment%20removal%20industrial%20workers%20safety%20gear%20professional%20industrial%20operations%20Texas%20refinery%20background&width=600&height=400&seq=texas-turnaround-002&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/70 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Professional Turnaround Support</h3>
                  <p>Coordinated equipment removal during planned shutdowns</p>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">TURNAROUND EQUIPMENT REMOVAL TEXAS</h2>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in <strong className="text-[#1B3A5F]">turnaround equipment removal</strong> and 
                <strong className="text-[#1B3A5F]"> refinery shutdown equipment</strong> purchasing throughout Texas. 
                Our experienced teams work within your schedule to maximize value from surplus assets.
              </p>
              
              <div className="space-y-6">
                {[
                  {
                    title: 'Pre-Turnaround Planning',
                    description: 'Equipment assessment and logistics coordination before shutdown begins'
                  },
                  {
                    title: 'Coordinated Removal',
                    description: 'Professional removal teams working within your turnaround schedule'
                  },
                  {
                    title: 'Above Scrap Pricing',
                    description: 'Fair market value for functional equipment, not scrap metal prices'
                  },
                  {
                    title: 'Complete Documentation',
                    description: 'Professional paperwork for asset disposal and regulatory compliance'
                  }
                ].map((service, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-white font-bold">{index + 1}</span>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{service.title}</h4>
                      <p className="text-gray-600">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All Texas Cities Dropdown - Add before FAQ */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="w-full flex items-center justify-between text-left"
            >
              <div>
                <h2 className="text-[#1B3A5F] text-3xl font-bold mb-2">
                  WE BUY SURPLUS VALVES IN ALL TEXAS CITIES
                </h2>
                <p className="text-gray-600 text-lg">
                  Click to view all {allTexasCities.length} Texas cities we serve
                </p>
              </div>
              <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-[#1B3A5F] text-4xl transition-transform duration-300`}></i>
            </button>
            
            {isExpanded && (
              <div className="mt-8 pt-8 border-t border-gray-200">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {allTexasCities.map((city, index) => (
                    <div
                      key={index}
                      className="bg-[#F5F7FA] rounded-lg p-4 hover:bg-[#1B3A5F] hover:text-white transition-all duration-300 cursor-pointer group"
                    >
                      <div className="flex items-center">
                        <i className="ri-map-pin-line mr-2 text-[#1B3A5F] group-hover:text-white"></i>
                        <span className="font-semibold">We Buy Valves {city} TX</span>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="mt-8 bg-[#1B3A5F]/10 rounded-lg p-6">
                  <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">
                    Texas Statewide Coverage
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We buy surplus valves, Fisher control valves, Rosemount transmitters, and industrial equipment 
                    in every Texas city. From major refining centers like Houston, Beaumont, and Corpus Christi to 
                    smaller industrial facilities throughout the state, our Texas team provides fast response times 
                    and competitive pricing for all your surplus equipment needs.
                  </p>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="flex items-center">
                      <i className="ri-time-line text-[#1B3A5F] mr-2"></i>
                      <span className="text-gray-700 font-semibold">4-8 Hour Response</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-money-dollar-circle-line text-[#1B3A5F] mr-2"></i>
                      <span className="text-gray-700 font-semibold">Above Scrap Pricing</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-truck-line text-[#1B3A5F] mr-2"></i>
                      <span className="text-gray-700 font-semibold">Professional Removal</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* FAQ Section - Add before Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">TEXAS VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment in Texas</p>
          </div>
          
          <div className="space-y-6">
            {[
              {
                question: "Do you buy valves from Texas refineries?",
                answer: "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Texas refineries including Houston, Beaumont, Port Arthur, Corpus Christi, and all Gulf Coast facilities. We provide fast 4-6 hour response times and competitive pricing for Texas operations."
              },
              {
                question: "What cities in Texas do you serve?",
                answer: "We serve all major Texas cities including Houston, Dallas, Austin, San Antonio, Beaumont, Corpus Christi, El Paso, and surrounding areas. We have local teams throughout Texas ready to respond quickly to your equipment purchasing needs."
              },
              {
                question: "How quickly can you respond to Texas facilities?",
                answer: "We provide 4-6 hour response times for Houston and Gulf Coast facilities, and 6-8 hour response times for other major Texas cities. Our local Texas teams have extensive refinery experience and can quickly evaluate your surplus equipment and provide competitive quotes."
              },
              {
                question: "What types of equipment do you buy in Texas?",
                answer: "We purchase all types of industrial equipment from Texas facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from refineries, petrochemical plants, and manufacturing facilities."
              },
              {
                question: "Do you handle turnaround equipment removal in Texas?",
                answer: "Absolutely! We specialize in turnaround equipment removal and refinery shutdown equipment purchasing throughout Texas. Our experienced teams work within your schedule to maximize value from surplus assets while maintaining full safety compliance and regulatory documentation."
              },
              {
                question: "What brands of valves do you buy in Texas?",
                answer: "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Texas refineries and industrial facilities."
              }
            ].map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-600 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Local Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL VALVES HOUSTON TX - LOCAL CONTACT</h2>
            <p className="text-gray-200 text-xl">Direct access to Texas industrial equipment buyers</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">TEXAS REGIONAL OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">24/7 Turnaround Support</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Lists & Photos</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">Houston Service Area</div>
                    <div className="text-gray-600">Serving all Texas refineries and petrochemical plants</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Texas Regional Manager</h4>
                <p className="text-gray-600">John Smith - 25+ years Texas refinery experience</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">WHY TEXAS REFINERIES CHOOSE US</h3>
              <div className="space-y-4">
                {[
                  'Highest prices for surplus valves in Texas',
                  'Fast 4-8 hour response times in Houston area',
                  'Professional turnaround coordination',
                  'Complete regulatory documentation',
                  'Local Texas team with refinery experience',
                  'Emergency shutdown equipment removal'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  GET TEXAS QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Texas;
